import { CSSObject } from '@chakra-ui/react';

export const TextFormInfo: CSSObject = {
  color: 'alpha.700',
};
